const pixboostConfig = {
  apiKey: "MjA5OTcwODkwMg__",
  domain: "images.officeworks.com.au",
  breakpoints: {
    lg: { media: "(min-width: 990px)" },
    md: { media: "(min-width: 640px)" },
    sm: {}
  }
};

export default pixboostConfig;
